import { useQuery } from '@/hooks/apollo/useQuery';
import { gql } from '@apollo/client';
import { TravelClubUser, Me } from '@/types/apollo';

const useUser = () => {
  const { loading, error, data } = useQuery<{
    travelClubUser: TravelClubUser;
    me: Me;
  }>(getTravelClubUser);

  if (error) {
    return { loading, error, travelClubUser: undefined, me: undefined };
  }

  return {
    loading,
    ...data,
  };
};

const getTravelClubUser = gql`
  query getTravelClubUser {
    travelClubUser {
      id
      nickName
      grade
      gradeKo
      pkgMinSavingRate
      travelClubAgtCodes
    }
    me {
      id
      canUseCustomTravel
      isLogin
    }
  }
`;

export default useUser;
